import { useCallback, useEffect } from "react";
import { useNavigate, useSearchParams } from "react-router";
import SplashScreen from "src/components/splash-screen";
import { paths } from "src/pages/paths";
import { useAuthContext } from "../hooks";

// ----------------------------------------------------------------------

interface Props {
	children: React.ReactNode;
}

export default function GuestGuard({ children }: Props) {
	const { loading } = useAuthContext();

	return <>{loading ? <SplashScreen /> : <Container>{children}</Container>}</>;
}

// ----------------------------------------------------------------------

function Container({ children }: Props) {
	const navigate = useNavigate();

	const [searchParams] = useSearchParams();

	const returnTo = searchParams.get("returnTo") ?? paths.dashboard.root;

	const { authenticated } = useAuthContext();

	const check = useCallback(() => {
		if (authenticated) {
			void navigate(returnTo);
		}
	}, [authenticated, returnTo, navigate]);

	useEffect(() => {
		// check();
	}, [check]);

	return <>{children}</>;
}
